export const CREATE_PAYROLL_ALLOWANCE = "CREATE_PAYROLL_ALLOWANCE";
export const FETCH_PAYROLL_ALLOWANCES = "FETCH_PAYROLL_ALLOWANCES";
export const EDIT_PAYROLL_ALLOWANCE = "EDIT_PAYROLL_ALLOWANCE";
export const DELETE_PAYROLL_ALLOWANCE = "DELETE_PAYROLL_ALLOWANCE";
